<template>
    <div style="margin-top: 30px; padding: 0 20px;">
        <div class="title">Hit Fortune Promo Rules</div>
        <div class="version">Last Updated: April, 12, 2024</div>
        <div class="content">
            RayaAustin LLC d/b/a Hit Fortune - Casino Slots(hereinafter, "Hit Fortune", "us" "our" or "ours") operates
            <a href="https://game.hitfortune.net" target="_blank">https://game.hitfortune.net</a>, a social gaming
            platform where you may purchase Gold Coins to play the Games in Standard Play for social, entertainment, and
            recreational purposes only. From time to time, we may offer free Sweepstakes Coins to Players who engage in
            certain qualifying activities which may be used as entries to play the Games in Promotional Play for a
            chance to win Prizes ("Promotion(s)"), according to these Promo Rules. To play Games in Promotional Play
            with Sweepstakes Coins, you must agree to these Promo Rules and our <span class="clickBtn"
                @click="onClickTS">Terms and Conditions</span>. These Promo Rules are intended to be read in conjunction
            with the Terms, and the Terms are incorporated herein by reference. The capitalized terms used in these
            Promo Rules have the same meaning as assigned to those terms in the Terms. The Promotions are subject to all
            applicable national, federal, state, and local laws and regulations. Redeeming a Prize is contingent upon
            fulfilling the requirements set forth in these Promo Rules.
        </div>
        <div class="content">
            NO PURCHASE OR PAYMENT IS NECESSARY TO PARTICIPATE IN THIS PROMOTION. A PURCHASE OR PAYMENT OF ANY KIND WILL
            NOT INCREASE A PARTICIPANT'S CHANCES OF WINNING. HIT FORTUNE DOES NOT OFFER ANY REAL MONEY GAMING. YOU
            UNDERSTAND AND AGREE THAT GOLD COINS CANNOT BE REDEEMED FOR CASH, GIFT CARDS, REWARDS, OR OTHER PRIZES OF
            VALUE. ONLY SWEEPSTAKES COINS THAT HAVE BEEN WON PLAYING THE GAME IN PROMOTIONAL PLAY MODE MAY BE EXCHANGED
            FOR CASH OR OTHER THINGS OF REAL-WORLD VALUE, AS WE MAY PERMIT FROM TIME TO TIME.
        </div>
        <div class="title1">
            1. Eligibility
        </div>
        <div class="content">
            The Promotions are open to Players (i) in the United States who do not reside in an Excluded Territory, as
            defined in the Terms and Conditions (ii) who are not Minors, and (iii) who own a Customer Account (an
            "Eligible Participant"). You cannot participate in the Promotions from outside the United States, in an
            Excluded Territory, nor in any jurisdiction where the Platform is illegal. You cannot participate in the
            Promotions if you are on the U.S. Treasury Department's list of Specially Designated Nationals, or if you
            are an immediate family member of an employee, distributor, associate, concessionary, or other agent of Hit
            Fortune.
        </div>
        <div class="content">
            Eligible Participants may engage in Standard Play or Promotional Play. Any Eligible Participant who engages
            in Promotional Play (hereinafter a "Promotional Player") agrees fully and unconditionally to these Promo
            Rules by doing so. These Promo Rules are final and binding in all matters relating to Promotional Play.
            Winning Prizes is contingent upon the Promotional Player fulfilling all requirements set out in these Promo
            Rules.
        </div>
        <div class="title1">
            2. Promotional Period
        </div>
        <div class="content">
            Hit Fortune is the sponsor and promoter of the Promotions. The Promotions run on the Platform concurrently
            with the business of selling Gold Coins for the sole purpose of socializing, entertainment, and recreation.
            Our servers are the official time-keeping device of the Promotions.
        </div>
        <div class="content">
            In any particular year, the Promotions will run until: (a) December 31st of that year, or (b) Hit Fortune
            provides thirty (30) days' notice of termination, whichever occurs first. Hit Fortune reserves the right to
            begin a new Promotion after any current Promotion ends or is terminated by Hit Fortune.
        </div>
        <div class="content">
            Hit Fortune further reserves the right to cancel, pause, modify, or suspend any part of or all the
            Promotions with immediate effect owing to events or circumstances outside of its reasonable control. Any
            event or circumstance impairing the proper functioning or integrity of the Promotions will be determined by
            Hit Fortune, and any corrective action (to the extent necessary) will be taken by Hit Fortune in its sole
            discretion.
        </div>
        <div class="title1">
            3. Sweepstakes Coins
        </div>
        <div class="content">
            You may receive free Sweepstakes Coins in the following ways:
        </div>
        <div class="content">
            1. receiving a specific number of free Sweepstakes Coins for logging on each day ("Daily Logon Reward"). The
            specific number of free Sweepstakes Coins may vary by day and is prominently displayed on the Platform.
            Promotional Players can receive free Sweepstakes Coins on a daily basis by taking the following steps: (i)
            sign into your Customer Account, if you are eligible, a pop up screen will appear for you to claim your
            Daily Logon Reward; and (ii) click the "Claim" button at the bottom of the Daily Logon Reward pop up.
            Promotional Players can only claim a Daily Logon Reward once per day (the daily clock resets at the time of
            a Promotional Player's last claim).
        </div>
        <div class="content">
            2. interacting with certain posts on our official social media accounts. The terms of any social media
            giveaway will be prominently displayed on our official social media accounts. The amount of Sweepstakes
            Coins given away will be stated on the applicable no-cost contest post, and will be credited to each contest
            winner's Customer Account.
        </div>
        <div class="content">
            3. receiving a specific number of free Sweepstakes Coins by mailing a request to ROOM 511, 5/F, MING SANG
            IND BLDG, 19-21 HING YIP STREET, KWUN TONG, KLN HONG KONG, on a standard, stamped, unfolded, blank,
            lineless, legibly handwritten 4"x6" postcard with the email address associated with your Customer Account,
            the full name shown on your government issued ID, your return residential address associated with your
            Customer Account, a unique 12 character alphanumeric Envelope Request Code generated by Hit Fortune for the
            purpose of identifying your Request Card efficiently, and the following statement: "<span
                style="font-style:italic;">I wish to receive free Sweepstakes Coins in order to participate in the
                promotion offered by Hit Fortune. By submitting this request, I hereby declare that I have read,
                understood and agree to be bound by Hit Fortune's Terms and Conditions and Promo Rules.</span>"
            ("Request Card ").
        </div>
        <div class="content">
            4. from time to time, by referring up to ten (10) new users according to our Referral Program, as set forth
            in our <span class="clickBtn" @click="onClickTS">Terms and Conditions</span> and according to the terms on
            our <span>Referral Program</span> page.
        </div>
        <div class="content">
            5. by purchasing certain packages of Gold Coins. Gold Coins can be used only for Standard Play. Gold Coins
            cannot be redeemed for prizes. The number of Sweepstakes Coins a Promotional Player will receive as a bonus
            for each relevant Gold Coin purchase will be stated in the website purchase window. All purchases of Gold
            Coins are final and no refunds will be given. Please note that Sweepstakes Coins cannot be purchased. Any
            Sweepstakes Coins received with the purchase of Gold Coins are incidental to and in connection with the
            promotion of Gold Coins. Hit Fortune reserves the right to limit or change the available payment methods to
            purchase Gold Coins.
        </div>
        <div class="content">
            Hit Fortune may change the balance of Sweepstakes Coins on your account at any time and for any reason, in
            its sole discretion, including removing Sweepstakes Coins associated with Inactive Accounts. Sweepstakes
            Coins are only valid for sixty (60) days from the date a Promotional Player last logged on to their Customer
            Account and will then automatically expire. Sweepstakes Coins may also be forfeited if a Promotional
            Player's Customer Account is closed for any reason, or at Hit Fortune's discretion.
        </div>
        <div class="content">
            For each Request Card submitted in accordance with the above requirements, the Promotional Player will
            receive three (3) Sweepstakes Coins. The Sweepstakes Coins will be added to the Promotional Player's
            Customer Account. There is a limit of one Request Card per outer envelope. Each unique Envelope Request Code
            generated by a Promotional Player may be used for one (1) individual Request Card. The Envelope Request Code
            on the Request Card must match the Envelope Request Code generated by the Promotional Player who is
            submitting theRequest Card. If the Envelope Request Code does not match the Promotional Player's Customer
            Account, the Sweepstakes Coins will not be credited to the Promotional Player's Customer Account. An
            Envelope Request Code can be obtained by navigating to the link in the footer of the lobby called 'Envelope
            Request Code' and following the prompts. The Promotional Player must ensure that their handwriting is
            legible on the Request Card. If the Promotional Player's handwriting is not legible, the entry will be void
            and the Sweepstakes Coins will not be credited to the Promotional Player's Customer Account. The legibility
            of a Promotional Player's handwriting will be determined by Hit Fortune in its sole discretion. THE REQUEST
            MUST ONLY BE MADE BY THE PROMOTIONAL PLAYER AND MUST BE POSTED FROM THE SAME U.S. STATE AS THE PROMOTIONAL
            PLAYER'S VERIFIED RESIDENTIAL ADDRESS (as set forth in their Customer Account). Requests made by any other
            individual or any entity (including but not limited to commercial sweepstakes subscription notification
            and/or entering services) or posted from a U.S. State different from the Promotional Player's verified
            residential address will be declared invalid and Sweepstakes Coins will not be credited to the Promotional
            Player's Customer Account. Tampering with the entry process or the operation of the Promotions, including
            but not limited to the use of any device to automate the Sweepstakes Coins request/entry process or to
            unfairly assist the Promotional Player with meeting the handwriting requirement, is prohibited and any
            requests/entries deemed by Hit Fortune, in its sole discretion, to have been submitted in this manner will
            be void. In the event a dispute regarding the identity of the individual who actually submitted a Request
            Card or whether a Request Card satisfies the requirements set out above cannot be resolved to Hit Fortune's
            satisfaction, the affected request/entry will be deemed ineligible.
        </div>
        <div class="title1">
            4. Games
        </div>
        <div class="content">
            You may use Sweepstakes Coins to play Games in Promotional Play for a chance to win Prizes. The Platform
            prominently displays: (1) the amount of Sweepstakes Coins required to play eachGame, (2) the Prizes you are
            able to obtain by playing each Game. Hit Fortune reserves the right to correct or void any error in the
            Games.
        </div>
        <div class="title1">
            5. Odds
        </div>
        <div class="content">
            The odds of winning Prizes depends on the Games played and the number of Sweepstakes Coins played, as set by
            Hit Fortune in its sole and exclusive discretion. Hit Fortune reserves the right to adjust the odds of
            winning the Promotions at any time. The odds of each game can be found within the game rules of each game.
        </div>
        <div class="content">
            5.2. In addition to these Terms, Sweepstakes Promotions offered through the Service have their own rules
            which are available on the Service. For current Rules, see official Sweepstakes Rules. It is Your
            responsibility to read the rules of a Game before playing. You must familiarize Yourself with the applicable
            terms of play and read the relevant rules before playing any Game.
        </div>
        <div class="title1">
            6. Prizes
        </div>
        <div class="content">
            Only Games played with Sweepstakes Coins in Promotional Play provide the opportunity to win Prizes which may
            be redeemed for cash or other things of real-world value. Hit Fortune reserves the right to change the
            amount of potential Prizes at any time. It is the Promotional Player's responsibility to check the potential
            Prizes on each occasion before they participate in the Promotion.
        </div>
        <div class="content">
            BEFORE YOU WILL BE ENTITLED TO ANY PRIZE, WINNERS ARE SUBJECT TO VERIFICATION BY HIT FORTUNE (IN ANY MANNER
            IT MAY CHOOSE) AND THE DECISIONS OF HIT FORTUNE ARE FINAL AND BINDING IN ALL MATTERS RELATED TO THE
            PROMOTIONS. A PROMOTIONAL PLAYER IS NOT A WINNER OF ANY PRIZE, EVEN IF THE ONLINE SCREEN INDICATES THEY ARE,
            UNLESS AND UNTIL THE PROMOTIONAL PLAYER'S ELIGIBILITY AND THE POTENTIAL WINNING PLAY HAS BEEN VERIFIED AND
            THE PROMOTIONAL PLAYER HAS FULLY COMPLIED WITH THESE PROMO RULES AND BEEN NOTIFIED THAT VERIFICATION IS
            COMPLETE. HIT FORTUNE WILL NOT ACCEPT SCREEN SHOTS OR OTHER PURPORTED EVIDENCE OF WINNING IN LIEU OF ITS
            VALIDATION PROCESS.
        </div>
        <div class="content">
            A potential Prize winner may be required to sign and return to Hit Fortune, an affidavit/declaration of
            eligibility, and liability/publicity release (except where prohibited) in order to claim his/her prize (if
            applicable). If a potential winner cannot be contacted, fails to properly execute and return the
            affidavit/declaration of eligibility and liability/publicity release within the required time period (if
            applicable), fails to comply with these Promo Rules, or if the Prize or Prize notification is returned as
            undeliverable, that potential winner forfeits the Prize. In the event that a potential winner of a Prize is
            disqualified for any reason, Hit Fortune may, in its sole discretion, reseed the Prize back into the
            Promotion.
        </div>
        <div class="content">
            To redeem Prizes, you must be an Eligible Participant, and your details must match those on your Customer
            Account. You cannot redeem Sweepstakes Coins for cash or other things of real-world value until your
            Sweepstakes Coins have been played through at least one (1) time, and you have met the minimum number of
            sufficiently played-through Sweepstakes Coins for your preferred withdrawal method. To withdraw Sweepstakes
            Coins as a gift card, you must have at least twenty (20) sufficiently played-through Sweepstakes Coins. To
            redeem Sweepstakes Coins as cash, you must have at least one hundred (100) sufficiently played-through
            Sweepstakes Coins. We may offer other withdrawal methods from time to time in our sole discretion, but we do
            not guarantee that additional withdrawal methods will be offered. The amount of sufficiently played-through
            Sweepstakes Coins needed to redeem a prize via other withdrawal methods may vary and will be prominently
            displayed on the prize redemption page or in the prize description. If you are a resident of New York and
            Florida, the maximum redemption value for a Prize won on any single spin or play is five thousand dollars
            ($5,000). If you are a resident of New York and Florida, any Prize with a value in excess of five thousand
            dollars ($5,000) will be reduced to a maximum value of five thousand dollars ($5,000). Prizes may be
            redeemed for cash or other thing of real-world value at a rate of one (1) Sweepstakes Coins to one (1)
            United States Dollar to the Customer Account which was used to buy Gold Coins or to a bank account or
            digital wallet selected by you, if this is not technically possible, provided that you own such bank account
            or digital wallet. Prizes in excess of ten thousand dollars ($10,000.00) may, at our election, be made by us
            to you in weekly installments. Our decision on how to manage the operation of the Games and how to award
            Prizes is final and binding. Any Prizes won due to a technical error are null and void. Violation of our
            <span class="clickBtn" @click="onClickTS">Terms and Conditions</span> makes any Prize null and void.
        </div>
        <div class="content">
            Prize winners will be notified by private message or email. Hit Fortune is not responsible for any taxes or
            fees associated with a Prize redemption. Promotional Players are responsible for all applicable taxes and
            fees associated with Prize receipt and/or redemption. Hit Fortune is not responsible for any foreign
            exchange transaction fees, charges, or related costs that may be incurred as a result of, or in relation to,
            a Prize redemption, including to any losses or additional costs arising from foreign exchange fluctuations.
            Sweepstakes Coins are not transferable and no substitution will be made except as provided herein at Hit
            Fortune's sole discretion. Hit Fortune reserves the right to substitute the listed Prize of equal or greater
            value for any reason owing to circumstances outside Hit Fortune's reasonable control.
        </div>
        <div class="title1">
            7. Verification
        </div>
        <div class="content">
            Before you redeem any Prizes, Hit Fortune may require you to provide certain verification documentation and
            information and sign certain forms within seven (7) days. If you fail to provide the requested documentation
            or information or sign the required forms in a timely manner, or if we determine that you have violated our
            <span class="clickBtn" @click="onClickTS">Terms and Conditions</span>, you will forfeit the Prize, and we
            may suspend or terminate your Customer Account. You agree that Hit Fortune is not responsible for any delays
            caused in the payment of Prizes, whatsoever.
        </div>
        <div class="title1">
            8. Release and Indemnification
        </div>
        <div class="content">
            You agree to hold Hit Fortune and our employees, clients, subsidiaries, affiliated companies, agents, media
            partners, officers, directors, content providers, and related parties not accountable for, and you will
            indemnify the same from, any and all costs, expenses, liabilities and damages that may arise as a result of
            your use of the Platform.
        </div>
        <div class="content">
            By entering the Promotions, and by using the Platform and playing the Games, you agree to release and hold
            harmless Hit Fortune and its parent, subsidiary, and affiliated companies, the Prize suppliers and any other
            organizations responsible for sponsoring, fulfilling, administering, advertising or promoting the
            Promotions, and all of their respective past and present officers, directors, employees, agents, and
            representatives (collectively, the "Released Parties") from and against any and all claims, expenses, and
            liability, including but not limited to negligence and damages of any kind to persons and property,
            including but not limited to invasion of privacy (under appropriation, intrusion, public disclosure of
            private facts, false light in the public eye or other legal theory), defamation, slander, libel, violation
            of right of publicity, infringement of trademark, copyright or other intellectual property rights, property
            damage, or death or personal injury arising out of or relating to (i) your creation of an entry or
            submission of an entry in the Promotions, (ii), acceptance, use or misuse of any Prizes (including any
            travel or activity related thereto), (iii) your use of the Platform, (iv) your participation in the
            Promotions, (v) the broadcast, exploitation or use of your entry in the Promotions by Hit Fortune, and (vi)
            your other uses of any services offered by Hit Fortune.
        </div>
        <div class="content">
            By entering the Promotions, you agree to indemnify, defend, and hold harmless Hit Fortune from and against
            any and all claims, expenses, and liabilities (including reasonable attorneys/legal fees) arising out of or
            relating to your participation in the Promotions.
        </div>
        <div class="title1">
            9. Publicity
        </div>
        <div class="content">
            Except where prohibited by law, your participation in the Promotions constitutes your consent to Hit
            Fortune's, and Hit Fortune's agents' use of your name, image, likeness, opinions, comments, photograph,
            voice, and/or geographic data (i.e., hometown, U.S. State of residency) for promotional purposes in any
            media, worldwide, without further payment, notice or consideration to you.
        </div>
        <div class="title1">
            10. Damages and Disqualification
        </div>
        <div class="content">
            Hit Fortune may actively seek damages from any person acting in bad faith to undermine the legitimate
            function of the Promotions to the fullest extent permitted by law. You may be disqualified from the
            Promotions if you violate our <span class="clickBtn" @click="onClickTS">Terms and Conditions</span>.
        </div>
        <div class="content">
            Hit Fortune reserves the right to cancel, suspend, and/or modify the Promotions or these Promo Rules, or any
            part thereof, with immediate effect owing to circumstances outside its reasonable control, including any
            fraud or technical failures, as determined by Hit Fortune in its sole discretion.
        </div>
        <div class="content">
            Hit Fortune reserves the right in its sole discretion to disqualify any individual it finds to be tampering
            with the entry process or the operation of the Promotions or to be acting in violation of these Promo Rules
            or in an unsportsmanlike or disruptive manner. Any attempt by any person to deliberately undermine the
            legitimate operation of the Promotions may be a violation of criminal and civil law and, should such an
            attempt be made, Hit Fortune reserves the right to seek damages from any such person to the fullest extent
            permitted by law. Hit Fortune's failure to enforce any term of these Promo Rules shall not constitute a
            waiver of that provision. In all other cases, Hit Fortune reserves the right to cancel, suspend, and/or
            modify the Promotions. Any notice regarding cancellation, suspension, and/or modification will be posted on
            the Platform.
        </div>
        <div class="content">
            Whenever we amend these Promo Rules in a way that would limit your current rights or which may be to your
            detriment, we will notify you upon your next visit to the Platform and you will be required to re-confirm
            your acceptance prior to participating in any Promotional Play. If you do not agree to the amended Promo
            Rules, you may not participate in any Promotional Play.
        </div>
        <div class="title1">
            11. Limitation of Liability
        </div>
        <div class="content">
            To the extent permitted by law, the Released Parties (as defined above in Section 8) are not responsible
            for:
        </div>
        <div class="content">
            1. any incorrect or inaccurate information, whether caused by a Promotional Player, coding error, or by any
            of the equipment or programming associated with or utilized in the Promotions;
        </div>
        <div class="content">
            2. technical failures of any kind, including, but not limited to malfunctions, interruptions, or
            disconnections in phone lines or network hardware or software;
        </div>
        <div class="content">
            3. unauthorized human intervention in any part of the entry process or the Promotions;
        </div>
        <div class="content">
            4. payment of any Prizes to a person who is not an Eligible Participant or who has not provided accurate and
            complete documentation required by Hit Fortune as a condition of payment;
        </div>
        <div class="content">
            5. technical or human error which may occur in the administration or operation of the Promotions; or
        </div>
        <div class="content">
            6. any injury or damage to persons or property which may be caused, directly or indirectly, in whole or in
            part, from your participation in the Promotions or receipt or use or misuse of any Prize.
        </div>
        <div class="content">
            If for any reason a Promotional Player's Sweepstakes Coins or winning play is confirmed to have been
            erroneously deleted, lost, or otherwise destroyed or corrupted, Promotional Player's sole remedy is
            replacement by Hit Fortune of an equivalent amount of Sweepstakes Coins.
        </div>
        <div class="title1">
            12. Miscellaneous
        </div>
        <div class="content">
            Under no circumstances will any Promotional Player be permitted to obtain awards for, and Promotional Player
            hereby waives all rights to claim, punitive, incidental, or consequential damages, or any other damages,
            including attorneys' fees, other than Promotional Player's actual out-of-pocket expenses (i.e., costs
            associated with participating in this Promotions), and Promotional Player further waives all rights to have
            damages multiplied or increased. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATIONS OR EXCLUSION OF LIABILITY
            FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE MAY NOT APPLY TO YOU.
        </div>
        <div class="content">
            All issues and questions concerning the construction, validity, interpretation, and enforceability of these
            Promo Rules, or the rights and obligations of the Promotional Player and Hit Fortune in connection with the
            Promotions, are governed by, and construed in accordance with, the laws of the State of Florida, without
            giving effect to any choice of law or conflict of law rules (whether of the State of Florida or any other
            jurisdiction), which would cause the application of the laws of any jurisdiction other than the State of
            Florida.
        </div>
        <div class="content">
            Any Promotional Player posting or seen to be posting comments on Hit Fortune's social media pages or
            elsewhere during any Promotion that are considered bullying, spiteful, or upsetting to other Promotional
            Players or any other user of the Platform, or directly aimed at Hit Fortune, will have their comments
            removed and will be disqualified from the Promotions. Hit Fortune reserves the right to alert the operators
            of any social media sites to any such behavior.
        </div>
        <div class="content_center">
            THE PROMOTION IS VOID WHERE PROHIBITED.
        </div>
        <div class="content_center">
            <p>© RayaAustin LLC (2024). All Rights Reserved.</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "TermsOfUseView",
    title: "Terms of Use",
    methods: {
        onClickHF: function () {
            this.$router.push("/")
        },
        onClickTS: function () {
            this.$router.push("TermsOfUse")
        },
    }
}
</script>
<style lang="scss" scoped>
* {
    font-size: 18px;
}

.title {
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 23px
}

.title1 {
    display: block;
    text-align: left;
    font-weight: bold;
}

.version {
    display: block;
    text-align: left;
}

.content {
    display: block;
    text-align: left;
}

.content_center {
    display: flex;
    justify-content: center;
    align-items: center;
}

p {
    font-style: italic;
}

.clickBtn {
    color: #245bdb;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
}

div {
    margin: 12px;
}
</style>